import e from "react";
import b from "classnames/bind";
import { u as i } from "./utils-C0l876fA.es.js";
import './InputLabel.css';const p = "InputLabel-module__labelContainer___kzrrq", I = "InputLabel-module__label___uYP64", L = "InputLabel-module__required___iOu05", f = "InputLabel-module__selected___rKLfF", q = "InputLabel-module__clear___zTEJY", E = "InputLabel-module__dark___iTjj1", l = {
  labelContainer: p,
  label: I,
  required: L,
  selected: f,
  clear: q,
  dark: E,
  "selected-label": "InputLabel-module__selected-label___mIBO8"
}, T = ({
  label: r,
  multiple: s,
  selectedCount: a = 0,
  onSelect: _ = () => {
  },
  clearAllText: n,
  dark: c = !1,
  inputId: o,
  required: u = !1,
  showClearAll: m = !1
}) => {
  const d = b.bind(l), { t } = i();
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: d({
        labelContainer: !0,
        dark: c
      })
    },
    r && /* @__PURE__ */ e.createElement("label", { className: l.label, htmlFor: o }, r, u && /* @__PURE__ */ e.createElement("span", { className: l.required }, " ", `(${t("required")})`)),
    (s || m) && a > 0 && /* @__PURE__ */ e.createElement("span", { className: l.selected }, t("selectedCountText", { selectedCount: a }), " // ", /* @__PURE__ */ e.createElement(
      "button",
      {
        className: l.clear,
        onClick: () => _([]),
        type: "button",
        "aria-label": `${t("selectedCountText", {
          selectedCount: a
        })}, ${n}`
      },
      n
    ))
  );
};
export {
  T as I
};
